module.exports = __webpack_public_path__ + "img/medal-green.af60c0ea.svg";